import axios from "axios";
import moment from "moment";
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

export const isEmpty = (value) => {
  if (value === null) {
    return true;
  }
  if (typeof value !== "number" && value === "") {
    return true;
  }
  if (value === "undefined" || value === undefined) {
    return true;
  }
  if (
    value !== null &&
    typeof value === "object" &&
    !Object.keys(value).length
  ) {
    return true;
  }
  return false;
};

export const getLoggedUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : {};
};

export const sendRequest = async (url, data) => {
  const method = data.method || "post";
  const payload = data.payload || {};
  const headers = data.headers || {};
  let token = payload.token;

  // if (isEmpty(token)) {
  //     const user = getLoggedUser();
  //     token = user._token;
  // }

  let axios_config = {
    method: method,
    url: url,
    headers: {
      "x-access-token": token,
      ...headers,
    },
    validateStatus: () => true, //Always resolve promise on every http status
  };
  if (method === "get") {
    axios_config["params"] = payload;
  } else {
    axios_config["data"] = payload;
  }
  try {
    const response = await axios(axios_config);
    if (response.status === 401) {
      //User's Token has been expired
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return response;
  } catch (error) {
    return error;
  }
};

export const successToast = (str, title) => {
  window?.toast?.show({
    severity: "success",
    summary: title || "Success",
    detail: str || "Operation completed successfully.",
  });
};

export const errorToast = (error, title, customMessage) => {
  const errorResponse = error?.response?.data?.message;
  window?.toast?.show({
    severity: "error",
    summary: title,
    detail: customMessage || errorResponse || "Some error occurred",
  });
};

export const getPreviousTimePeriod = (period) => {
  if (period === "month") {
    const currentDate = moment().format("YYYY-MM-DD");

    const previousDate = moment().subtract(1, "months").format("YYYY-MM-DD");
    return { fromDate: previousDate, toDate: currentDate };
  }

  if (period === "half_year") {
    const currentDate = moment().format("YYYY-MM-DD");

    const previousDate = moment().subtract(6, "months").format("YYYY-MM-DD");
    return { fromDate: previousDate, toDate: currentDate };
  }

  if (period === "year") {
    const currentDate = moment().format("YYYY-MM-DD");

    const previousDate = moment().subtract(1, "year").format("YYYY-MM-DD");
    return { fromDate: previousDate, toDate: currentDate };
  }
};

function convertJsonToCsv(jsonData) {
  let csv = "";

  // Extract the column headers
  const headers = Object.keys(jsonData[0]);

  // Build the header row
  csv += headers.join(",") + "\n";

  // Build the data rows
  jsonData.forEach((row) => {
    const values = headers.map((header) => {
      let cellValue = `${row[header]}`;
      if (["agencyId", "busId", "chargerId"].includes(header)) {
        cellValue =
          header === "agencyId"
            ? `${row[header]?.name}`
            : `${
                row[header][
                  header === "busId" ? "busNumberPlate" : "chargerNumberPlate"
                ]
              }`;
      }

      // Check if the value needs to be escaped
      const escapedValue = cellValue.includes(",")
        ? `"${cellValue}"`
        : cellValue;
      return escapedValue;
    });
    csv += values.join(",") + "\n";
  });

  return csv;
}

export const handleExport = async (result, fileName) => {
  if (result?.data?.length < 1) {
    errorToast(false, "No Data", "No Data Available");
    return;
  }

  const csvData = convertJsonToCsv(result.data);

  const blob = new Blob([csvData], { type: "text/csv" });

  // Create a download link
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);

  // Append the link to the body and trigger the download
  document.body.appendChild(link);
  link.click();

  // Clean up the URL and link
  link.parentNode.removeChild(link);
  URL.revokeObjectURL(url);
};

export const capitalizeFirstLetter = (string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
};

export const areDatesWithinOneYear = (fromDate, toDate) => {
  const oneYearInMillis = 365 * 24 * 60 * 60 * 1000; // Approximate milliseconds in a year

  const fromDateObj = new Date(fromDate);
  const toDateObj = new Date(toDate);

  // Calculate the difference in milliseconds
  const dateDifference = toDateObj - fromDateObj;

  return dateDifference > oneYearInMillis;
};

export const handleDownloadTemplate = (blob, fileName) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const handleDownloadFileTemplate = async (fileName, apiRoute) => {
  const url =
    process.env.NODE_ENV === "development"
      ? `http://localhost:8000/api/${apiRoute}`
      : `${process.env.REACT_APP_API_BASE_URL}/${apiRoute}`;
  axios({
    url: `${url}/download-template`, // Update with your API endpoint
    method: "GET",
    responseType: "blob", // Important: response type must be 'blob' for file download
  }).then((response) => {
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.xlsx`;
    link.click();
  });
};

export const limitDecimalToFourDigits = (number) => {
  // Convert to number and round to 4 decimal places
  if (!number) {
    return "N/A";
  }
  let decimalPlaces = number % 1 !== 0 ? 4 : 0; // Check if decimal places exist
  return parseFloat(number).toFixed(decimalPlaces);
};
